import { CrossSellingPointer } from "../../others";
import { RCL } from ".";
import $ from "jquery";
/**
 * Pagination (needs to be extract as class to avoid multiple event triggers).
 */

class CrossRclPagination {
  static onClick(e) {
    const href = $(this).attr("href");
    new CrossSellingPointer($(this), RCL, "pagination"); // Still redirect after clicking a button

    $(this).pointer("widget").find(".button").click(() => {
      // Wait a second, because browsers like Firefox cancel the dismiss request
      setTimeout(() => window.open(href, "_self"), 1000);
    });
    $(CrossRclPagination.SELECTOR).off("click", CrossRclPagination.onClick);
    e.preventDefault();
    return false;
  }

  static bind() {
    CrossSellingPointer.isActionAvailable(RCL, "pagination") && $(this.SELECTOR).one("click", this.onClick);
  }

}

CrossRclPagination.SELECTOR = "body.wp-admin.edit-php:not(.post-type-attachment) .tablenav-pages .pagination-links a";
export { CrossRclPagination };